import templateStr from 'text!./templates/ctrl-group.html';

var inputId = 0;

export default (function () {
    return {
        require: ['?^form', '?^ngForm'],
        transclude: true,
        scope: {
            label: '@?',
            readonly: '=?',
            model: '=',
            currency: '@',
            flavor: '@',
            hideInputLabel: '<?',
            explicitErrorMessage: '@?',
            prequelRequired: '@?',
            required: '@?'
        },
        template: templateStr,

        controller: ['$scope', '$timeout', function ($scope, $timeout) {
            if (!$scope.model) {
                throw new Error('Input with label "' + $scope.label + '" has an undefined model scope value');
            }

            $scope.pristine = true;
            // once a different value is set on the model then we mark the field as not pristine
            $scope.$watch('model.value', function (newValue, oldValue) {
                $scope.pristine = !$scope.pristine ? false : newValue === oldValue;
            });

            $scope.$timeout = $timeout;
        }],

        link: function link(scope, element, attrs, ctrls) {
            var parentForm = ctrls[0];

            if (parentForm && !parentForm.invalidInputs) {
                parentForm.invalidInputs = []; // The IDs of invalid inputs, used to $anchorScroll to correct element
            }
            var validityFn = function validityFn() {
                // If the model is a coverage term, use the coveragePublicID property
                var publicID = scope.model.coveragePublicID ? scope.model.coveragePublicID : scope.model.publicID;
                if (!scope.model.aspects.valid && parentForm && parentForm.invalidInputs && !parentForm.invalidInputs.includes(publicID)) {
                    parentForm.invalidInputs.push(publicID);
                } else if (scope.model.aspects.valid) {
                    removeInvalidInput(publicID);
                }

                return scope.model.aspects.valid;
            };

            function removeInvalidInput(publicID) {
                if (parentForm && parentForm.invalidInputs.includes(publicID)) {
                    var i = parentForm.invalidInputs.indexOf(publicID);
                    parentForm.invalidInputs.splice(i, 1);
                }
            }

            var setPristineFn = function setPristineFn() {
                // we need to use this postDigest function here because the
                // watch on 'model.value' in the controller gets called after
                // this function is called even though the model was changed first
                scope.$$postDigest(function () {
                    scope.pristine = true;
                    scope.$apply();
                });
            };
            if (parentForm) {
                var removeListenerFn = parentForm.addModelControl(validityFn, setPristineFn);
                scope.$on('$destroy', function () {
                    removeInvalidInput();
                    return removeListenerFn();
                });
            }

            if (!('readonly' in scope) && attrs.readonly === '') {
                // if readonly attr exists with no value then set it to true
                scope.readonly = true;
            }
            scope.isVisible = function () {
                return !('visible' in scope.model.aspects) || scope.model.aspects.visible;
            };

            scope.inputId = inputId++;

            scope.showError = function () {
                var formHasBeenSubmitted = parentForm ? parentForm.submitted : true;
                if (angular.isDefined(parentForm) && parentForm.$name === 'editInsuredForm' && scope.model._accessorCode == 'mSFOfficialID_EXT') {
                    if (scope.model.value === undefined || scope.model.value == '') {
                        return true;
                    }
                }
                if (angular.isDefined(parentForm) && parentForm.$name === 'namedInsuredForm' && scope.model._accessorCode == 'mSFEntityType_EXT') {
                    if (scope.model.value === undefined || scope.model.value == '') {
                        return true;
                    }
                }

                if (!scope.model.aspects.valid && !scope.pristine || !scope.model.aspects.valid && formHasBeenSubmitted) {
                    return true;
                }
            };
            //For required symbol to appear in front for Qualification_MSF
            scope.prequalRequired = function () {
                if (scope.model.label != null && scope.model.label != undefined) {
                    if (scope.model.type == "SELECT") return false;
                    if (scope.model.code == 'z0giie47dg57j091efrr7h8dv59') return false;
                    if (scope.model.label.includes('questionkey') || scope.model.label.includes('questionkey')) return true;
                }
                //Required symbol for FEIN in edit named insured form
                if (angular.isDefined(parentForm) && parentForm.$name === 'editInsuredForm' && scope.model._accessorCode == 'mSFOfficialID_EXT') {
                    return true;
                }
                if (!scope.required) {
                    if (scope.model._accessorCode == 'mSFEntityType_EXT') {
                        return true;
                    }
                }return false;
            };

            element.on('focusin', function () {
                scope.focused = true;
                scope.$apply();
            });
            element.on('focusout', function () {
                scope.focused = false;
                // Wrap apply in timeout function so that it can safely run in the next digest cycle
                scope.$timeout(function () {
                    return scope.$apply();
                });
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/basicinputs/CtrlGroupDirective.js
// module id = 156
// module chunks = 0